import * as React from "react";
import Shell from "../layout/shell";
import { Hero } from "../components/hero";
import { ImageFeatureBlock } from "../components/imageFeatureBlock";
import { isHeroSlice, isImageFeatureBlock, isBigBulletSlice, isCardLayout } from "../helpers/prismicHelpers";
import { BigBullets } from "../components/bigBullets";
import { Cards } from "../components/cards";
import "./index.scss";

var Index = function Index(_ref) {
  var data = _ref.data;
  var content = data.prismic.allHome_pages.edges[0].node;
  return /*#__PURE__*/React.createElement(Shell, null, /*#__PURE__*/React.createElement("div", {
    className: "home-view"
  }, content.body.map(function (slice, index) {
    if (isHeroSlice(slice)) {
      return /*#__PURE__*/React.createElement(Hero, {
        data: slice,
        showAnimation: index === 0,
        className: index === 0 ? 'hero-alt' : ''
      });
    }

    if (isCardLayout(slice)) {
      return /*#__PURE__*/React.createElement(Cards, {
        data: slice
      });
    }

    if (isImageFeatureBlock(slice)) {
      return /*#__PURE__*/React.createElement(ImageFeatureBlock, {
        data: slice
      });
    }

    if (isBigBulletSlice(slice)) {
      return /*#__PURE__*/React.createElement(BigBullets, {
        data: slice
      });
    }
  })));
};

export default Index;
export var query = "2257433264";